var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('footer',{staticClass:"text-white",attrs:{"id":"Footer"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-sm-6 col-12 text-sm-left text-center"},[_c('p',[_vm._v(_vm._s(_vm.year)+" @ Arentia Academy | Portugal")])])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }